export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "testName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Test name"])},
        "score": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Score"])},
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])},
        "noResults": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There are no results to show yet."])}
      },
      "nl-NL": {
        "testName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Test naam"])},
        "score": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultaat"])},
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datum"])},
        "noResults": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There are no results to show yet."])}
      }
    }
  })
}
